import { __extends } from "tslib";
import { EventDispatcher, UUID } from '@awayjs/core';
import { PickEntity } from './base/PickEntity';
import { RaycastPicker } from './pick/RaycastPicker';
import { BoundsPicker } from './pick/BoundsPicker';
import { TabPicker } from './pick/TabPicker';
/**
 * @class away.pool.PickGroup
 */
var PickGroup = /** @class */ (function (_super) {
    __extends(PickGroup, _super);
    /**
     * //TODO
     *
     * @param materialClassGL
     */
    function PickGroup() {
        var _this = _super.call(this) || this;
        _this.id = UUID.Next();
        _this._raycastPickerPool = new RaycastPickerPool(_this);
        _this._boundsPickerPool = new BoundsPickerPool(_this);
        _this._tabPickerPool = PickGroup._tabPickerPool || (PickGroup._tabPickerPool = new TabPickerPool());
        return _this;
    }
    PickGroup.getInstance = function () {
        return PickGroup._instance || (PickGroup._instance = new PickGroup());
    };
    PickGroup.prototype.requestAbstraction = function (asset) {
        return PickEntity;
    };
    PickGroup.prototype.getRaycastPicker = function (partition) {
        return partition.getAbstraction(this._raycastPickerPool);
    };
    PickGroup.prototype.getBoundsPicker = function (partition) {
        return partition.getAbstraction(this._boundsPickerPool);
    };
    PickGroup.prototype.getTabPicker = function (partition) {
        return partition.getAbstraction(this._tabPickerPool);
    };
    return PickGroup;
}(EventDispatcher));
export { PickGroup };
var RaycastPickerPool = /** @class */ (function () {
    function RaycastPickerPool(pickGroup) {
        this.id = UUID.Next();
        this.pickGroup = pickGroup;
    }
    RaycastPickerPool.prototype.requestAbstraction = function (assetClass) {
        return RaycastPicker;
    };
    return RaycastPickerPool;
}());
export { RaycastPickerPool };
var BoundsPickerPool = /** @class */ (function () {
    function BoundsPickerPool(pickGroup) {
        this.id = UUID.Next();
        this.pickGroup = pickGroup;
    }
    BoundsPickerPool.prototype.requestAbstraction = function (assetClass) {
        return BoundsPicker;
    };
    return BoundsPickerPool;
}());
export { BoundsPickerPool };
var TabPickerPool = /** @class */ (function () {
    function TabPickerPool() {
        this.id = UUID.Next();
    }
    TabPickerPool.prototype.requestAbstraction = function (assetClass) {
        return TabPicker;
    };
    return TabPickerPool;
}());
